var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('b-form-group',{staticClass:"mb-2",attrs:{"id":"document","label":("" + (_vm.$t('documents.type')) + (_vm.required ? '*' : '')),"label-for":"document"}},[_c('b-dropdown',{staticClass:"w-100",attrs:{"id":"document","text":_vm.getDocument ? _vm.$getLocale(_vm.getDocument.name) : _vm.$t('documents.type'),"variant":_vm.docType
          ? 'outline-success'
          : _vm.required
          ? 'outline-danger'
          : 'outline-secondary'}},_vm._l((_vm.docTypes),function(type,i){return _c('b-dropdown-item',{key:i,attrs:{"disabled":_vm.age < 0
            ? false
            : _vm.age < 14
            ? type.code == 0
              ? true
              : false
            : type.code == 4
            ? true
            : false},on:{"click":function($event){return _vm.$emit('type', type._id)}}},[_vm._v(" "+_vm._s(_vm.$getLocale(type.name))+" ")])}),1)],1),_c(_vm.getDocType,{tag:"component",attrs:{"document":_vm.docNumber,"type":_vm.docType,"required":_vm.required},on:{"number":function($event){return _vm.$emit('number', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }